import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Cookies from 'js-cookie';
import { addSeconds, differenceInSeconds } from 'date-fns';
import { EmailApi } from '~/core/api';
import BaseFullscreenDialog from '~/core/components/Base/BaseFullscreenDialog.vue';
import { ConfirmMailAction } from '~/core/enums';
import { DIALOG_MESSAGE as CORE_DIALOG, TIMER_TIMEOUT } from '~/core/constants';
import { useToggleable } from '~/core/composables';
import { useConfirmEmail } from '~/core/composables/useConfirmEmail';
import { SNACKBAR_MESSAGE as CORE_SNACKBAR } from '~/core/constants/snackbar';
import useMainSnackbarStore from '~/stores/useMainSnackbarStore';
import useMainDialogStore from '~/stores/useMainDialogStore';
import useMedcardStore from '~/stores/useMedcardStore';
import useProfileStore from '~/stores/useProfileStore';
import { MailStatus } from '~/features/Profile/enums';
import ConfirmMailForm from './ConfirmMailForm.vue';
var COOKIE_TIMER_KEY = 'mail_confirmation_timer';
export default defineComponent({
  name: 'ConfirmMail',
  components: {
    BaseFullscreenDialog: BaseFullscreenDialog,
    ConfirmMailForm: ConfirmMailForm
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    hideConfirmationSupport: {
      type: Boolean,
      default: false
    }
  },
  emits: ['email:confirmed', 'email:changed', 'click:close', 'input', 'email:limit', 'click:reset'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      expose = _ref.expose;
    var refProps = toRefs(props);
    var _useNuxtApp = useNuxtApp(),
      $featureFlag = _useNuxtApp.$featureFlag;
    var profileStore = useProfileStore();
    var medcardStore = useMedcardStore();
    var currentAction = ref(ConfirmMailAction.Addition);
    var changeEmailStep = ref(1);
    var formKey = ref(Date.now());
    var mailLoading = ref(false);
    var resendTimeout = ref(TIMER_TIMEOUT);
    var isDailyLimitOccurred = ref(false);
    var $dialog = useMainDialogStore();
    var $snackbar = useMainSnackbarStore();
    var $route = useRoute();
    var _useToggleable = useToggleable(refProps.value, emit, 'input'),
      isActive = _useToggleable.isActive,
      hide = _useToggleable.hide;
    var _useConfirmEmail = useConfirmEmail(),
      storeEmail = _useConfirmEmail.storeEmail,
      masterMedcardToken = _useConfirmEmail.masterMedcardToken;
    var title = computed(function () {
      switch (currentAction.value) {
        case ConfirmMailAction.Medcard:
          return 'Подтверждение почты';
        case ConfirmMailAction.Addition:
          return 'Укажите почту';
        default:
          return 'Электронная почта';
      }
    });
    var singleFormRequest = computed(function () {
      if (currentAction.value === ConfirmMailAction.Addition) {
        return confirmEmailAddition;
      }
      return confirmEmailMedcard;
    });
    var singleFormConfirm = computed(function () {
      if (currentAction.value === ConfirmMailAction.Addition) {
        return requestEmailAddition;
      }
      return requestEmailMedcard;
    });
    watch(resendTimeout, function () {
      if (isDailyLimitOccurred.value || currentAction.value === ConfirmMailAction.Change && changeEmailStep.value === 2) {
        Cookies.remove(COOKIE_TIMER_KEY);
        return;
      }
      setCookieTimeout();
    });

    /** public */
    function show(_x) {
      return _show.apply(this, arguments);
    }
    function _show() {
      _show = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(action) {
        var currentTimestamp, _Cookies$get, _Cookies$get2, _e$response, _e$response$data, _e$response$data$emai, errorCode, isConfirmed;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!isActive.value) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              isDailyLimitOccurred.value = false;
              currentTimestamp = Date.now();
              resendTimeout.value = TIMER_TIMEOUT;
              _context.prev = 5;
              formKey.value = currentTimestamp;
              isActive.value = true;
              currentAction.value = action;
              changeEmailStep.value = 1;
              if (!(currentAction.value !== ConfirmMailAction.Addition)) {
                _context.next = 28;
                break;
              }
              mailLoading.value = true;
              if (!(currentAction.value === ConfirmMailAction.Medcard)) {
                _context.next = 20;
                break;
              }
              if (!(((_Cookies$get = Cookies.get(COOKIE_TIMER_KEY)) === null || _Cookies$get === void 0 ? void 0 : _Cookies$get.split('/')[1]) === ConfirmMailAction.Medcard)) {
                _context.next = 18;
                break;
              }
              setResendTimeout();
              _context.next = 17;
              return setupMedcardMasterToken();
            case 17:
              return _context.abrupt("return");
            case 18:
              _context.next = 20;
              return requestEmailMedcard();
            case 20:
              if (!(currentAction.value === ConfirmMailAction.Change)) {
                _context.next = 28;
                break;
              }
              if (!(((_Cookies$get2 = Cookies.get(COOKIE_TIMER_KEY)) === null || _Cookies$get2 === void 0 ? void 0 : _Cookies$get2.split('/')[1]) === ConfirmMailAction.Change)) {
                _context.next = 26;
                break;
              }
              setResendTimeout();
              _context.next = 25;
              return setupMedcardMasterToken();
            case 25:
              return _context.abrupt("return");
            case 26:
              _context.next = 28;
              return requestEmailChange();
            case 28:
              _context.next = 50;
              break;
            case 30:
              _context.prev = 30;
              _context.t0 = _context["catch"](5);
              if (!(currentTimestamp !== formKey.value)) {
                _context.next = 34;
                break;
              }
              return _context.abrupt("return");
            case 34:
              errorCode = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_e$response = _context.t0.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : (_e$response$data$emai = _e$response$data.email) === null || _e$response$data$emai === void 0 ? void 0 : _e$response$data$emai.code;
              if (!(errorCode === MailStatus.DailyLimit)) {
                _context.next = 45;
                break;
              }
              mailLoading.value = false;
              isDailyLimitOccurred.value = true;
              _context.next = 40;
              return $dialog.open(_objectSpread({}, CORE_DIALOG.CODE_COOLDOWN));
            case 40:
              isConfirmed = _context.sent;
              if (isConfirmed) {
                emit('email:limit');
              }
              hide();
              Cookies.remove(COOKIE_TIMER_KEY);
              return _context.abrupt("return");
            case 45:
              _context.next = 47;
              return $dialog.open(_objectSpread({}, CORE_DIALOG.GLOBAL_ERROR));
            case 47:
              hide();
              emit('click:close');
              Cookies.remove(COOKIE_TIMER_KEY);
            case 50:
              _context.prev = 50;
              if (currentTimestamp === formKey.value) {
                mailLoading.value = false;
              }
              return _context.finish(50);
            case 53:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[5, 30, 50, 53]]);
      }));
      return _show.apply(this, arguments);
    }
    function setResendTimeout() {
      var cookieTime = Cookies.get(COOKIE_TIMER_KEY);
      try {
        if (cookieTime && cookieTime.split('/')[1] === currentAction.value) {
          resendTimeout.value = Math.min(differenceInSeconds(new Date(cookieTime.split('/')[0]), new Date()), TIMER_TIMEOUT);
        }
      } catch (_unused) {
        Cookies.remove(COOKIE_TIMER_KEY);
        resendTimeout.value = TIMER_TIMEOUT;
      }
    }
    function handleFirstStepComplete() {
      return _handleFirstStepComplete.apply(this, arguments);
    }
    function _handleFirstStepComplete() {
      _handleFirstStepComplete = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(changeEmailStep.value === 1)) {
                _context2.next = 5;
                break;
              }
              changeEmailStep.value++;
              _context2.next = 4;
              return nextTick();
            case 4:
              Cookies.remove(COOKIE_TIMER_KEY);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _handleFirstStepComplete.apply(this, arguments);
    }
    function setupMedcardMasterToken() {
      return _setupMedcardMasterToken.apply(this, arguments);
    }
    function _setupMedcardMasterToken() {
      _setupMedcardMasterToken = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return medcardStore.getMasterToken();
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _setupMedcardMasterToken.apply(this, arguments);
    }
    function requestEmailChange() {
      return _requestEmailChange.apply(this, arguments);
    }
    function _requestEmailChange() {
      _requestEmailChange = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return setupMedcardMasterToken();
            case 2:
              _context4.next = 4;
              return EmailApi.requestChange({
                masterMedcardToken: masterMedcardToken.value
              });
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _requestEmailChange.apply(this, arguments);
    }
    function confirmEmailChange(_x2) {
      return _confirmEmailChange.apply(this, arguments);
    }
    function _confirmEmailChange() {
      _confirmEmailChange = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref2) {
        var secretCode;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              secretCode = _ref2.secretCode;
              _context5.next = 3;
              return EmailApi.confirmChange({
                secretCode: secretCode,
                masterMedcardToken: masterMedcardToken.value
              });
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return _confirmEmailChange.apply(this, arguments);
    }
    function requestEmailAddition(_x3) {
      return _requestEmailAddition.apply(this, arguments);
    }
    function _requestEmailAddition() {
      _requestEmailAddition = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref3) {
        var email;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              email = _ref3.email;
              if (!(!$featureFlag('wff_fix_email_change') || currentAction.value === ConfirmMailAction.Addition)) {
                _context6.next = 4;
                break;
              }
              _context6.next = 4;
              return setupMedcardMasterToken();
            case 4:
              _context6.next = 6;
              return EmailApi.requestAddition({
                email: email,
                masterMedcardToken: masterMedcardToken.value
              });
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return _requestEmailAddition.apply(this, arguments);
    }
    function setEmail(email) {
      profileStore.email = email;
    }
    function confirmEmailAddition(_x4) {
      return _confirmEmailAddition.apply(this, arguments);
    }
    function _confirmEmailAddition() {
      _confirmEmailAddition = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref4) {
        var secretCode, email, _yield$EmailApi$confi, data;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              secretCode = _ref4.secretCode, email = _ref4.email;
              _context7.next = 3;
              return EmailApi.confirmAddition({
                email: email,
                secretCode: secretCode,
                masterMedcardToken: masterMedcardToken.value
              });
            case 3:
              _yield$EmailApi$confi = _context7.sent;
              data = _yield$EmailApi$confi.data;
              setEmail(email);
              _context7.next = 8;
              return medcardStore.setMedcardToken(data.medcardToken);
            case 8:
              if ($route.params.achievementAction) {
                $snackbar.open(CORE_SNACKBAR.MAIL_CONFIRMED_WITH_ACHIEVEMENT);
              }
            case 9:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return _confirmEmailAddition.apply(this, arguments);
    }
    function requestEmailMedcard() {
      return _requestEmailMedcard.apply(this, arguments);
    }
    function _requestEmailMedcard() {
      _requestEmailMedcard = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return setupMedcardMasterToken();
            case 2:
              _context8.next = 4;
              return EmailApi.requestMedcard({
                masterMedcardToken: masterMedcardToken.value
              });
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      return _requestEmailMedcard.apply(this, arguments);
    }
    function confirmEmailMedcard(_x5) {
      return _confirmEmailMedcard.apply(this, arguments);
    }
    function _confirmEmailMedcard() {
      _confirmEmailMedcard = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(_ref5) {
        var secretCode, email, _yield$EmailApi$confi2, data;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              secretCode = _ref5.secretCode, email = _ref5.email;
              _context9.next = 3;
              return EmailApi.confirmMedcard({
                secretCode: secretCode,
                masterMedcardToken: masterMedcardToken.value
              });
            case 3:
              _yield$EmailApi$confi2 = _context9.sent;
              data = _yield$EmailApi$confi2.data;
              setEmail(email);
              _context9.next = 8;
              return medcardStore.setMedcardToken(data.medcardToken);
            case 8:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      return _confirmEmailMedcard.apply(this, arguments);
    }
    function handleEmailConfirmed() {
      hide();
      Cookies.remove(COOKIE_TIMER_KEY);
      emit('email:confirmed');
    }
    function handleEmailChanged() {
      hide();
      emit('email:changed');
    }
    function handleClickClose() {
      emit('click:close');
    }
    function handleClickResetMedcard() {
      emit('click:reset');
      hide();
    }
    function setCookieTimeout() {
      if (currentAction.value === ConfirmMailAction.Medcard || currentAction.value === ConfirmMailAction.Change) {
        Cookies.set(COOKIE_TIMER_KEY, "".concat(addSeconds(new Date(), resendTimeout.value).toISOString(), "/").concat(currentAction.value), {
          expires: addSeconds(new Date(), resendTimeout.value)
        });
      } else if (Cookies.get(COOKIE_TIMER_KEY)) {
        Cookies.remove(COOKIE_TIMER_KEY);
      }
    }
    function getChangeSecondStepTitle(step) {
      return step === MailStatus.Sent ? 'Отправили код на новую почту' : '';
    }
    expose({
      show: show,
      confirmEmailMedcard: confirmEmailMedcard,
      // Для теста
      requestEmailMedcard: requestEmailMedcard //
    });
    return {
      resendTimeout: resendTimeout,
      ConfirmMailAction: ConfirmMailAction,
      currentAction: currentAction,
      changeEmailStep: changeEmailStep,
      formKey: formKey,
      mailLoading: mailLoading,
      isActive: isActive,
      storeEmail: storeEmail,
      title: title,
      singleFormRequest: singleFormRequest,
      singleFormConfirm: singleFormConfirm,
      isDailyLimitOccurred: isDailyLimitOccurred,
      handleFirstStepComplete: handleFirstStepComplete,
      requestEmailChange: requestEmailChange,
      confirmEmailChange: confirmEmailChange,
      requestEmailAddition: requestEmailAddition,
      confirmEmailAddition: confirmEmailAddition,
      handleEmailConfirmed: handleEmailConfirmed,
      handleEmailChanged: handleEmailChanged,
      handleClickClose: handleClickClose,
      handleClickResetMedcard: handleClickResetMedcard,
      getChangeSecondStepTitle: getChangeSecondStepTitle
    };
  }
});